// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "container-3f7j9";
var _4 = "fareName-zYLHa";
var _5 = "services-Z3agN";
var _6 = "service-2jYCK";
var _7 = "service_selected-2UvR3";
var _8 = "service__icon-3kCxp";
var _9 = "service__add-3sFie";
var _a = "wrapper-witOT";
export { _1 as "__esModule", _2 as "tablet", _3 as "container", _4 as "fareName", _5 as "services", _6 as "service", _7 as "service_selected", _8 as "service__icon", _9 as "service__add", _a as "wrapper" }
export default { "__esModule": _1, "tablet": _2, "container": _3, "fareName": _4, "services": _5, "service": _6, "service_selected": _7, "service__icon": _8, "service__add": _9, "wrapper": _a }
